export default "__VITE_ASSET__BNwmd7Z2__";